import { useIntl } from "react-intl";

interface ReservationNextStepsProps {
  type: "flight" | "hotel";
}

export const ReservationNextSteps = ({ type }: ReservationNextStepsProps) => {
  const intl = useIntl();
  const showFlightInfo = type === "flight";
  const showHotelInfo = type === "hotel";

  return (
    <section className="mt-4">
      <h3 className="section-title">
        {intl.formatMessage({ id: "reservations.whatsNext" })}
      </h3>
      <div className="section-card flex flex-col gap-2 text-sm">
        {showFlightInfo ? (
          <p>
            {intl.formatMessage({
              id: "reservations.flight.whatsNextDescription",
            })}
          </p>
        ) : null}
        {showHotelInfo ? (
          <p>
            {intl.formatMessage({
              id: "reservations.hotel.whatsNextDescription",
            })}
          </p>
        ) : null}
      </div>
    </section>
  );
};
